import { MatCardModule } from '@angular/material/card';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MethodPaymentComponent } from './method-payment.component';
import { MatDividerModule } from '@angular/material/divider';
import { CdkTableModule } from "@angular/cdk/table";



@NgModule({
  declarations: [
    MethodPaymentComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatDividerModule,
    TranslateModule,
    CdkTableModule
],
  exports: [
    MethodPaymentComponent
  ]
})
export class MethodPaymentModule { }
